import {
  TileLayout,
  TileLayoutRepositionEvent,
  Drawer,
  DrawerContent,
} from "@progress/kendo-react-layout";
import { useSelector } from "react-redux";
import { getSidebarStatusSelector } from "../Slices/SidebarSlice";
import { getMenuStatusSelector } from "../Slices/MenuSlice";
import { getParamsSelector } from "../Slices/ParamSlice";
import { PDFExport } from "@progress/kendo-react-pdf";
import React, { Fragment, useState, useEffect, PropsWithChildren } from "react";
import { useAppDispatch } from "../../Core/store.hooks";
import Information from "../../Information";
import SidebarItem from "./SidebarItem";
import useWindowDimensions from "../Hooks/windowDimensionsHook";

import {
  Card,
  CardHeader,
  CardTitle,
  CardBody,
  CardActions,
  CardImage,
  CardSubtitle,
  Avatar,
} from "@progress/kendo-react-layout";

interface DashboardProps {
  savedPositionData: any;
  sidebarItems: any;
  widgets?: any | null;
  exportCounter: number;
  resetCounter: number;
  repositionHandler: any;
  originalPositionData: any;
  removeWidget: any;
  removeStatic: any;
  addRemove?: boolean;
  staticContent?: any;
  customSize?: any;
}
interface SidebarItemProps {
  item: any;
  title: string;
  expanded: boolean;
  default: boolean;
}

const Dashboard = (propsArgs: PropsWithChildren<DashboardProps>) => {
  const pdfExportComponent = React.useRef<PDFExport>(null);
  const _sidebarOpen = useSelector(getSidebarStatusSelector);
  const _menuOpen = useSelector(getMenuStatusSelector);
  const { height, width } = useWindowDimensions();
  const globalParams = useSelector(getParamsSelector);
  const dispatch = useAppDispatch();

  const args = {
    ...propsArgs,
  };
  const [children, updateChildrentt] = useState<any>([]);
  const [removedIDs, updateRemovedIds] = useState<string[]>([]);
  const [fullScreenID, updateFullScreenID] = useState<string | null>(null);
  const [positionData, setPositionData] = React.useState<Array<any>>([]);
  const [isFullScreen, setIsFullScreen] = useState<boolean>(false);
  const [drawerExpanded, setDrawerExpanded] = React.useState(true);
  const [positionChangeCounter, updatePositionChangeCounter] = useState(0);
  const [informationVisible, updateInformationVisible] = useState(false);
  const [infoId, updateInfoId] = useState("101");

  useEffect(() => {
    updateFullScreenID(null);
    setIsFullScreen(false);
    updateRemovedIds([]);
    if (args.widgets != null) {
      if (args.widgets.length > 0) {
        let newChildren: any = [];

        for (var i = 0; i < args.widgets.length; i++) {
          let newWidget: any = null;
          newWidget = args.widgets[i];
          if (newWidget != null) {
            newChildren.push(newWidget);
          }
        }
        updateChildrentt(newChildren);
      }
    }
  }, [args.widgets]);

  useEffect(() => {
    if (propsArgs.savedPositionData != undefined && positionChangeCounter > 0) {
      setPositionData(propsArgs.savedPositionData);
    }
    updatePositionChangeCounter(positionChangeCounter + 1);
  }, [propsArgs.savedPositionData]);

  //useEffect(() => {
  //  console.log(args.addRemove);
  //}, [args.addRemove]);

  useEffect(() => {
    if (propsArgs.resetCounter > 0) {
      setPositionData(propsArgs.originalPositionData);
      updateFullScreenID(null);
      setIsFullScreen(false);
      updateRemovedIds([]);
      updateChildrentt(args.widgets);
    }
  }, [propsArgs.resetCounter]);
  useEffect(() => {
    if (propsArgs.exportCounter > 0) exportPDFWithComponent();
  }, [propsArgs.exportCounter]);

  const makeFullScreen = (id: string) => {
    fullScreenID != null ? updateFullScreenID(null) : updateFullScreenID(id);
  };
  function fullscreenHandler(setToFull: boolean, id: string) {
    setIsFullScreen(setToFull);
    updateFullScreenID(id);
    if (!setToFull) updateFullScreenID(null);
  }
  const toggleInformation = () => {
    informationVisible
      ? updateInformationVisible(false)
      : updateInformationVisible(true);
  };
  function infoHandler(id: string) {
    updateInfoId(id);
    updateInformationVisible(true);
  }
  function closeStaticHandler(id: string) {
    args.removeStatic(id);
  }
  function closeHandler(id: string) {
    updateFullScreenID(null);
    setIsFullScreen(false);

    const noneRemovedIDs: string[] = [];
    const newPositionData: any = [];
    for (let k = 0; k < children.length; k++) {
      if (removedIDs.indexOf(children[k].props.id) < 0) {
        noneRemovedIDs.push(children[k].props.id);
      }
    }
    for (let i = 0; i < noneRemovedIDs.length; i++) {
      if (noneRemovedIDs[i] == id) {
        for (let j = 0; j < positionData.length; j++) {
          if (j != i) newPositionData.push(positionData[j]);
        }
        break;
      }
    }
    setPositionData(newPositionData);
    args.repositionHandler(newPositionData);
    let newChildren: any = [];
    let exists: boolean = false;
    if (children != null) {
      for (var k = 0; k < children.length; k++) {
        if (id != children[k].props.id) {
          newChildren.push(children[k]);
        }
      }
      updateChildrentt(newChildren);
    }

    args.removeWidget(id);
  }
  function checkFullScreenIDExists() {
    for (var i = 0; i < children.length; i++) {
      if (children[i].props.id == fullScreenID) return true;
    }
    return false;
  }
  function renderChildren() {
    if (children == null || children.length < 1) {
      return null;
    } else {
      const childrenWithProps = React.Children.map(children, (child: any) => {
        if (React.isValidElement(child as React.ReactElement<any>)) {
          if (fullScreenID != null && checkFullScreenIDExists()) {
            if (child.props.id == fullScreenID) {
              return React.cloneElement(child as React.ReactElement<any>, {
                makeFullScreen,
              });
            }
          } else {
            return React.cloneElement(child as React.ReactElement<any>, {
              makeFullScreen,
            });
          }
        }
      });
      const tiles: any = [];
      let idCounter = 0;
      if (childrenWithProps == null) return tiles;
      childrenWithProps.forEach((element: any) => {
        idCounter++;
        const obj: any = {};
        if (
          element.props.header != null &&
          element.props.header != undefined &&
          element.props.header != ""
        ) {
          obj.body = element;
          if (!element.props.static) {
            obj.header = (
              <span>
                <span className="k-card-header-title">
                  {" "}
                  {element.props.header}{" "}
                </span>
                {isFullScreen ? (
                  <Fragment>
                    {(args.addRemove || args.addRemove == null) && (
                      <span
                        style={{
                          float: "right",
                          marginLeft: "5px",
                        }}
                        title="Remove component"
                        onClick={() => closeHandler(element.props.id)}
                        className="k-icon k-i-close"
                      ></span>
                    )}
                    <span
                      style={{
                        float: "right",
                        fontSize: "13px",
                        marginTop: "1px",
                      }}
                      title="Exit Full screen"
                      onClick={() => fullscreenHandler(false, element.props.id)}
                      className="k-icon k-i-fullscreen-exit"
                    ></span>
                  </Fragment>
                ) : (
                  <Fragment>
                    {(args.addRemove || args.addRemove == null) && (
                      <span
                        style={{
                          float: "right",
                          marginLeft: "5px",
                        }}
                        title="Remove component"
                        onClick={() => closeHandler(element.props.id)}
                        className="k-icon k-i-close"
                      ></span>
                    )}
                    <span
                      style={{
                        float: "right",
                        fontSize: "13px",
                        marginTop: "1px",
                      }}
                      title="Full screen"
                      onClick={() => fullscreenHandler(true, element.props.id)}
                      className="k-icon k-i-fullscreen"
                    ></span>
                  </Fragment>
                )}
              </span>
            );
          } else {
            obj.header = element.props.header;
          }
          obj.hintClassName = "k-header-override";
        } else {
          obj.item = element;
        }
        obj.id = element.props.id;
        if (!element.props.static) {
          obj.reorderable = true;
          obj.resizable = true;
        } else {
          obj.reorderable = false;
          obj.resizable = false;
        }
        tiles.push(obj);
      });
      return tiles;
    }
  }
  const handleReposition = (e: TileLayoutRepositionEvent) => {
    args.repositionHandler(e.value);
  };
  const exportPDFWithComponent = () => {
    if (
      pdfExportComponent != null &&
      pdfExportComponent.current &&
      pdfExportComponent.current != null
    ) {
      pdfExportComponent.current.save();
    }
  };
  const getRowHeight = () => {
    let areaHeight: number = window.innerHeight;
    if (areaHeight > 1000) areaHeight = 1000;
    if (_menuOpen) {
      return (areaHeight - 330) / 12;
    }
    return (areaHeight - 122) / 12;
  };

  const renderStaticContent = () => {
    if (Array.isArray(args.staticContent) && args.staticContent.length > 0) {
      return (
        <div>
          {args.staticContent.map((content, index) => (
            <div
              key={index}
              style={{
                margin: "10px",
                marginBottom: "0",
                backgroundColor: "#fff",
                borderRadius: "3px",
              }}
            >
              <Card>
                <CardHeader>
                  {" "}
                  <div style={{ position: "relative" }}>
                    {content.props.header}

                    {args.addRemove ||
                      (args.addRemove == null && (
                        <span
                          style={{
                            position: "absolute",
                            top: "5px",
                            right: "5px",
                            marginLeft: "5px",
                          }}
                          title="Remove component"
                          onClick={() => closeStaticHandler(content.props.id)}
                          className="k-icon k-i-close"
                        ></span>
                      ))}
                    {content.props.infoId != null && (
                      <span
                        style={{
                          position: "absolute",
                          top: "5px",
                          right:
                            (args.addRemove || args.addRemove == null) &&
                            content.props.infoId
                              ? "30px"
                              : "5px",
                          marginLeft: "5px",
                        }}
                        title="Info component"
                        onClick={() => infoHandler(content.props.infoId)}
                        className="k-icon k-i-info"
                      ></span>
                    )}
                  </div>
                </CardHeader>
                <CardBody>{content}</CardBody>
              </Card>
            </div>
          ))}
        </div>
      );
    }
    return null; // Return null if staticContent is null or an empty array
  };

  const getDashboardHeight = () => {
    if (_menuOpen) {
      return "calc(100vh - 142px)";
    }
    return "calc(100vh - 62px)";
  };
  const getColumnTotal = () => {
    return propsArgs.customSize != null ? propsArgs.customSize : 6;
  };

  const renderDBContent = () => {
    let newPositionData = JSON.parse(JSON.stringify(positionData));
    if (children == null || children.length == 0) return null;
    if (width < 1000) {
      for (var i = 0; i < newPositionData.length; i++) {
        newPositionData[i].col = 1;
        newPositionData[i].colSpan = 6;
      }
    }
    if (height < 600) {
      for (var i = 0; i < newPositionData.length; i++) {
        newPositionData[i].rowSpan = 6;
      }
    }
    if (height < 400) {
      for (var i = 0; i < newPositionData.length; i++) {
        newPositionData[i].rowSpan = 10;
      }
    }
    if (positionData.length == 0) return null;
    if (propsArgs.savedPositionData.length == 0) {
      return <div style={{ backgroundColor: "#fff" }}>Loading...</div>;
    }
    if (positionData.length < children.length) {
      //failsafe
      newPositionData = [
        ...positionData,
        { col: 1, colSpan: 3, rowSpan: 3 },
        { col: 4, colSpan: 3, rowSpan: 3 },
        { col: 1, colSpan: 3, rowSpan: 3 },
        { col: 4, colSpan: 3, rowSpan: 3 },
        { col: 1, colSpan: 3, rowSpan: 3 },
        { col: 4, colSpan: 3, rowSpan: 3 },
        { col: 1, colSpan: 3, rowSpan: 3 },
        { col: 4, colSpan: 3, rowSpan: 3 },
        { col: 1, colSpan: 3, rowSpan: 3 },
        { col: 4, colSpan: 3, rowSpan: 3 },
        { col: 1, colSpan: 3, rowSpan: 3 },
        { col: 4, colSpan: 3, rowSpan: 3 },
        { col: 1, colSpan: 3, rowSpan: 3 },
        { col: 4, colSpan: 3, rowSpan: 3 },
        { col: 1, colSpan: 3, rowSpan: 3 },
        { col: 4, colSpan: 3, rowSpan: 3 },
        { col: 1, colSpan: 3, rowSpan: 3 },
        { col: 4, colSpan: 3, rowSpan: 3 },
        { col: 1, colSpan: 3, rowSpan: 3 },
        { col: 4, colSpan: 3, rowSpan: 3 },
        { col: 1, colSpan: 3, rowSpan: 3 },
        { col: 4, colSpan: 3, rowSpan: 3 },
        { col: 1, colSpan: 3, rowSpan: 3 },
        { col: 4, colSpan: 3, rowSpan: 3 },
      ];
    }
    const renderTiles = () => {
      if (children == null || children.length == 0) {
        return null;
      }
      return (
        <TileLayout
          positions={
            isFullScreen
              ? [{ col: 1, colSpan: getColumnTotal(), rowSpan: 12 }]
              : newPositionData
          }
          autoFlow="row dense"
          columns={getColumnTotal()}
          rowHeight={getRowHeight()}
          gap={{ rows: 15, columns: 10 }}
          items={renderChildren()}
          onReposition={handleReposition}
          dataItemKey={"id"}
          ignoreDrag={(e) => {
            return (
              !e.target.classList.contains("k-card-header") &&
              !e.target.classList.contains("k-resize-handle") &&
              !e.target.classList.contains("widgetHeaderInner")
            );
          }}
        />
      );
    };

    if (positionData.length < children.length) {
      //failsafe
      newPositionData = [
        ...positionData,
        { col: 1, colSpan: 6, rowSpan: 3 },
        { col: 1, colSpan: 3, rowSpan: 3 },
        { col: 4, colSpan: 3, rowSpan: 3 },
        { col: 1, colSpan: 3, rowSpan: 3 },
        { col: 4, colSpan: 3, rowSpan: 3 },
        { col: 1, colSpan: 3, rowSpan: 3 },
        { col: 4, colSpan: 3, rowSpan: 3 },
        { col: 1, colSpan: 3, rowSpan: 3 },
        { col: 4, colSpan: 3, rowSpan: 3 },
        { col: 1, colSpan: 3, rowSpan: 3 },
        { col: 4, colSpan: 3, rowSpan: 3 },
        { col: 1, colSpan: 3, rowSpan: 3 },
        { col: 4, colSpan: 3, rowSpan: 3 },
        { col: 1, colSpan: 3, rowSpan: 3 },
        { col: 4, colSpan: 3, rowSpan: 3 },
        { col: 1, colSpan: 3, rowSpan: 3 },
        { col: 4, colSpan: 3, rowSpan: 3 },
        { col: 1, colSpan: 3, rowSpan: 3 },
        { col: 4, colSpan: 3, rowSpan: 3 },
        { col: 1, colSpan: 3, rowSpan: 3 },
        { col: 4, colSpan: 3, rowSpan: 3 },
        { col: 1, colSpan: 3, rowSpan: 3 },
        { col: 4, colSpan: 3, rowSpan: 3 },
      ];
    }
    if (positionData.length == 0) return null;
    if (propsArgs.savedPositionData.length == 0) {
      return <div style={{ backgroundColor: "#fff" }}>Loading...</div>;
    }

    return (
      <div
        className="pp-dashboard-content"
        style={{ height: getDashboardHeight() }}
      >
        <PDFExport
          scale={0.3}
          ref={pdfExportComponent}
          paperSize="auto"
          margin={40}
          fileName={`Report for ${
            new Date().getFullYear() +
            " " +
            new Date().getMonth() +
            " " +
            new Date().getDay()
          }`}
          author="Fleet Management"
        >
          {" "}
          {renderStaticContent()}
          {renderTiles()}
        </PDFExport>
      </div>
    );
  };
  if (args.sidebarItems == null || args.sidebarItems.length == 0)
    return <div> {renderDBContent()}</div>;
  return (
    <div className="pp-dashboard-drawer">
      <Drawer
        expanded={_sidebarOpen}
        mode="push"
        width={220}
        items={args.sidebarItems}
        item={SidebarItem}
        style={{ backgroundColor: "454347" }}
      >
        <DrawerContent>
          <div>{renderDBContent()}</div>
        </DrawerContent>
      </Drawer>
      <Information
        visible={informationVisible}
        toggleVisible={toggleInformation}
        id={infoId}
      />
    </div>
  );
};
export default Dashboard;
